import React from 'react';
import {
  FiUsers,
  FiUpload,
  FiEdit3,
  FiMessageSquare,
  FiTrendingUp,
  FiPercent,
  FiFileText,
} from 'react-icons/fi';
import DashboardCardGrid from '../components/DashboardCardGrid';

const DAR_CARD_DATA = [
  {
    title: 'Distributors Manage',
    description: 'Add and update distributor.',
    path: '/DarDistributor',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiUsers size={28} />,
    accent: '#0ea5e9',
  },
  {
    title: 'Upload DAR-Questions',
    description: 'DAR-Analysis questions upload.',
    path: '/DarQuestion-uplode',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiUpload size={28} />,
    accent: '#8b5cf6',
  },
  {
    title: 'Update DAR-Questions',
    description: 'DAR-Analysis questions.',
    path: '/Update-DarQuestions',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiEdit3 size={28} />,
    accent: '#06b6d4',
  },
  {
    title: 'Answer DAR-Questions',
    description: 'DAR-Analysis questions answer.',
    path: '/Take-DarAnalysis',
    roles: ['Hr', 'ProjectManager', 'AdminController', 'Distributor'],
    icon: <FiMessageSquare size={28} />,
    accent: '#0d9488',
  },
  {
    title: 'View Potential Level',
    description: 'DAR-Analysis answer.',
    path: '/Dar-Potentiallevel',
    roles: ['Hr', 'ProjectManager', 'AdminController', 'Distributor'],
    icon: <FiTrendingUp size={28} />,
    accent: '#6366f1',
  },
  {
    title: 'View Potential %',
    description: 'DAR-Analysis weightage in %.',
    path: '/DarAnswer-value',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiPercent size={28} />,
    accent: '#14b8a6',
  },
  {
    title: 'DAR-Analysis Full Answers',
    description: 'DAR-Analysis weightage table.',
    path: '/DarFullAnswer',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiFileText size={28} />,
    accent: '#f59e0b',
  },
];

export default function CardGridDashboard() {
  return (
    <DashboardCardGrid
      pageTitle="DAR Analysis"
      pageSubtitle="Manage distributors, questions, answers, and potential levels"
      cardData={DAR_CARD_DATA}
    />
  );
}
